<template>
  <v-dialog
    v-model="dialog"
    :width="500"
  >
    <template #activator="{ on: tooltip }">
      <v-btn
        icon
        v-on="{ ...tooltip, ...dialog }"
        @click="btnClick"
      >
        <v-icon>mdi-information</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <v-icon
          :color="getColor(player.nb_days)"
          class="mr-3"
        >
          mdi-alert-outline
        </v-icon>
        {{ $t("notification.information") }}
      </v-card-title>
      <v-card-text>
        {{ $t("notification.subscription") }} <b> {{ player.name }} </b> {{ $t("notification.license") }} <br />
        <b> {{ player.identifier }} </b>
        <span v-if="player.nb_days > 0">
          {{
            " " +
            $t("profile.sections.account.number-renewal").toLowerCase() +
            " " +
            player.nb_days +
            " " +
            $t("notification.days") +
            formatDate(player.dt_expire)
          }}
        </span>
        <span v-else>
          {{ $t("notification.expire") }}
        </span>
      </v-card-text>
      <v-card-text>
        {{ $t("notification.contact") }}
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="copy(player)">
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
        <!--
          <v-btn
            @click="mailto(player)"
          >
            <v-icon>
              mdi-email-outline
            </v-icon>
          </v-btn>
        -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Libs
const moment = require("moment");

export default {
  props: {
    currentObject: {
      type: Object,
      default: () => {},
    },
    player: {
      type: Object,
      default: () => {},
    },
    icon: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dblclick: false,
      dialog: false,
    };
  },
  methods: {
    btnClick() {
      this.$emit("btn-click");
      this.dialog = true;
    },
    copy(player) {
      const text = player.name + " : " + player.identifier;

      // Only work in https
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          //
        });
      } else {
        const dummy = document.createElement("input");
        document.body.appendChild(dummy);
        dummy.setAttribute("value", text);
        dummy.select();
        document.execCommand("copy");
        dummy.remove();
      }
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getColor(nb) {
      if (nb < 0) {
        return "red";
      } else {
        return "yellow";
      }
    },
    mailto(player) {
      const mail = "dsa@displaymedia.fr";
      const subject = this.$t("notification.sub-renewal");
      const body = this.$t("notification.sub_body") + player.identifier;
      window.location.href = "mailto:" + mail + "?subject=" + subject + "&body=" + body;
      this.dialog = false;
    },
  },
};
</script>

<style></style>
